import { render, staticRenderFns } from "./common-item-bank.vue?vue&type=template&id=131c9440"
import script from "./common-item-bank.vue?vue&type=script&lang=js"
export * from "./common-item-bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports